import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
// import { rows } from "./../MastersFakeDb";
import {
  editDeleteCylinderHoldingLimit,
  getCylinderHoldingLimitList,
} from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const FinishedGoodReport = () => {
  const dispatch = useDispatch();
  // const login_details = sessionStorage.getItem('loginUser');
  // const userD = JSON.parse(login_details);
  // const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.cly_holding_limit.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.cly_holding_limit.rows_per_page || 15);
  const rows = useSelector((state) => state.cly_holding_limit.cly_holding_limit);

  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "cust_name", "prod_code", "max_holding"];
  const labels = ["Id", "cust_name", "prod_code", "max_holding"];

  const [successMessage, setSuccessMessage] = useState(null);
  //const respMsgState = "test";

  const respMsgState = useSelector((state) => state.cly_holding_limit.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = () => {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    dispatch(getCylinderHoldingLimitList(params));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getCylinderHoldingLimitList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  // useEffect(() => {
  //   fetchData();
  // }, [controller.page, controller.rowsPerPage]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => {}, [shouldShowMsg, responseMessage]);

  const deleteRecord = (id) => {
    dispatch(
      editDeleteCylinderHoldingLimit({
        chl_id: id,
        changedUpdatedValue: "delete",
      })
    );
    setIsDelete(false);
    fetchData();
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);
  useEffect(() => {
  }, [shouldShowMsg, responseMessage,]);



  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });




  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "Finished Good Report" },
          ]}
        />


        <HeaderSection
          title="Finished Good Report"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Finished Good Report"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          showAddButton={false} 
        />


        <Paper sx={{ width: '100%',  }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)}>
                    Cylinder Code
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    Product Name
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    Product Code
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    Quantity
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    UOM
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    No Of Cylinder Count
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("max_holding", sortBy, setSortBy, rows)
                    }
                  >
                    Location
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      {/* <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/masters/add-cylinder-holding-limit"
                        />
                      </StyledTableCell> */}
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={`${styles.list_table_body}`}
                      >
                        {row.max_holding}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          // deleteID={deleteInfo?.chl.id || null}
          deleteID={deleteInfo?.chl_id || null}
          displayName={deleteInfo?.cust_name || ""}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default FinishedGoodReport;
